import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ChannelActiveRegionEntity } from '../../domain/entities/ChannelActiveRegionEntity'
import type { ChannelActiveRegionCoverImageRequestAdmin } from '@/backend/market'

export class ChannelActiveRegionModel extends ChannelActiveRegionEntity {
  regionId?: number
  regionName?: string | null
  channelActiveRegionCoverImages?: Array<ChannelActiveRegionCoverImageRequestAdmin>
  constructor(dataDto: ChannelActiveRegionModel) {
    super()
    mapEntityProperties<ChannelActiveRegionEntity>(this, dataDto, {
      map: {
        region: {
          id: dataDto.regionId,
          name: dataDto.regionName
        },
        coverImages: dataDto.channelActiveRegionCoverImages
      }
    })
  }
}
